import Script from "next/script";
import React from "react";

const index = () => {
  return (
    <div>
      <div id="sf-root" />
      <Script
        type="text/javascript"
        src="//embed.salefindersa.com/169"
        strategy="afterInteractive"
      />
    </div>
  );
};
export default index;

// import React from "react";
// const Catalogue = () => {
//   return <iframe src="/catalogue.html" height="800" width="100%" />;
// };
// export default Catalogue;
